import React from 'react';
export function FolderOpenIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 21a.996.996 0 01-1-1V6a3 3 0 013-3h2.058a3 3 0 012.847 2.051L10.22 6H19a1 1 0 011 1v3h1a1 1 0 01.949 1.316l-3 9A1 1 0 0118 21H3zM4 6v7.838l1.051-3.154A1 1 0 016 10h12V8H9.5a1 1 0 01-.949-.684l-.544-1.632A1 1 0 007.058 5H5a1 1 0 00-1 1zm.387 13H17.28l2.334-7H6.72l-2.334 7z"
  }));
}